import { settings } from './../settings';
import { tools } from './../helpers/tools';
import { dom } from './../helpers/dom';
import { opus } from './../api/opus';

class HealthDeclaration {
    constructor(underscore, hd) {
        this._ = underscore;
        this.hd = hd;
        this.config = null;
        this.saveCallback = null;
    }

    init(newSettings) {
        const self = this;
        self.hd.opus = opus;

        settings.init(newSettings);
        opus.init();
    }

    load(saveCallback) {
        const self = this;
        let ispatient = false;

        self.saveCallback = saveCallback;

        opus.getPatientStatus()
            .then((status) => {
                ispatient = !status.result;
                self.show(ispatient);
            })
            .catch(() => {})
            .finally(() => {
                if (ispatient) {
                    opus.getHealth()
                        .then((response) => {
                            if (response && response.result && response.result.registrationDate) {
                                $('#hd-mp-health-lastreg').text(
                                    tools.formatToISODate(new Date(response.result.registrationDate))
                                );
                            }
                        })
                        .catch((response) => {
                            $('.hd-mp-section').hide();
                            $('#hd-mp-loading').show();

                            tools.handleError(self, response, $('#hd-mp-loading-error'));
                        });
                }
            });
    }

    show(ispatient) {
        const self = this;

        $('#hd-mp-health-notpat').toggle(!ispatient);
        $('#hd-health-container').toggle(ispatient);

        if (!ispatient) {
            return;
        }

        settings.settings.sections.map((section) => {
            var sectiontemplate = self._.template($('#tmpl-health-header').html());

            $('#header-' + section.name).html(sectiontemplate(section));
        });

        var datetemplate = self._.template($('#tmpl-health-pregnancydate').html());

        for (var i = 0; i < 10; i++) {
            var now = new Date();
            var current = new Date(now.getFullYear(), now.getMonth(), 15);
            var then = new Date(current.setMonth(current.getMonth() + i));
            var month = then.toLocaleString('sv-se', { month: 'long' });

            $('#fields-pregnancy').append(
                datetemplate({
                    value: then.getFullYear() + '-' + (then.getMonth() + 1),
                    date: month.charAt(0).toUpperCase() + month.slice(1) + ', ' + then.getFullYear(),
                })
            );
        }

        $('.health-required')
            .off('change')
            .on('change', function () {
                self.validateTextField(this);
            });

        $(':radio[name="health-tobaccoUse_smoke"]').change(() => {
            var chk = document.getElementById('health-tobaccoUse_smoke_yes');
            $(chk).parent().find('.health-medic').toggle(chk.checked);
        });

        $(':radio[name="health-cancer_affected"]').change(() => {
            var chk = document.getElementById('health-cancer_affected_yes');
            $(chk).parent().find('.health-medic').toggle(chk.checked);
        });

        $('.health-illness')
            .off('click')
            .on('click', function () {
                var chk = this;
                $(chk).parent().find('.health-medic').toggle(chk.checked);
            });

        $('.onoffswitch-checkbox')
            .off('click')
            .on('click', function () {
                var chk = this;
                if (chk.checked) {
                    document.getElementById('health-withoutRemark').checked = false;
                }
            });

        $('#health-withoutRemark')
            .off('click')
            .on('click', function () {
                var chk = this;
                if (chk.checked) {
                    settings.settings.sections.map((section) => {
                        document.getElementById('switch-' + section.name).checked = false;
                        $('#collapse-' + section.name).collapse('hide');
                    });
                }
            });

        $('#accordion-heartCondition .health-illness').on('click', function () {
            const section = $.grep(settings.settings.sections, (el) => {
                return el.name === 'heartCondition';
            });

            let any = false;
            section[0].fields.map((field) => {
                if (document.getElementById('health-' + field.name).checked) {
                    any = true;
                }
            });

            $('#hd-heartConditionRequired').toggle(!any);
        });

        $('#hd-mp-health-save')
            .off('click')
            .on('click', function (e) {
                self.saveHealth(e);
            });
    }

    saveHealth(e) {
        e.preventDefault();

        const self = this;
        let firstErrorAt = null;
        let valid = true;
        let request = {};

        $('#hd-health-saved').hide();

        dom.toggleSpinner('#hd-mp-health-save', true);

        const withoutRemark = document.getElementById('health-withoutRemark').checked;

        if (!withoutRemark) {
            // Heart condition
            if (document.getElementById('switch-heartCondition').checked) {
                request.heartCondition = {
                    heartConditions: {},
                    hasCondition: true,
                };

                const section = $.grep(settings.settings.sections, (el) => {
                    return el.name === 'heartCondition';
                });

                let any = false;
                section[0].fields.map((field) => {
                    if (document.getElementById('health-' + field.name).checked) {
                        const medic = document.getElementById('health-medic-' + field.name);

                        any = true;
                        valid = self.validateTextField(medic) && valid;

                        const result = {
                            hasCondition: true,
                            medications: medic.value,
                        };

                        if (field.name === 'heartCondition_other') {
                            const other = document.getElementById('health-other-' + field.name);

                            valid = self.validateTextField(other) && valid;

                            result.conditionDescription = other.value;
                        }

                        request.heartCondition.heartConditions[field.name.replace('heartCondition_', '')] = result;
                    }
                });

                valid = any && valid;

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-heartCondition';
                }
            }

            // High blood pressure
            if (document.getElementById('switch-highBloodPressure').checked) {
                const medic = document.getElementById('health-medic-highBloodPressure');
                valid = self.validateTextField(medic) && valid;

                request.highBloodPressure = {
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-highBloodPressure';
                }
            }

            // Diabetes
            if (document.getElementById('switch-diabetes').checked) {
                const medic = document.getElementById('health-medic-diabetes');
                const types = document.getElementsByName('health-diabetes_type');
                const treatments = [];

                let type = null;

                for (let i = 0; i < types.length; i++) {
                    if (types[i].checked) {
                        type = types[i].value;
                        break;
                    }
                }

                if (document.getElementById('health-diabetes_diet').checked) {
                    treatments.push(document.getElementById('health-diabetes_diet').value);
                }
                if (document.getElementById('health-diabetes_pills').checked) {
                    treatments.push(document.getElementById('health-diabetes_pills').value);
                }
                if (document.getElementById('health-diabetes_insulin').checked) {
                    treatments.push(document.getElementById('health-diabetes_insulin').value);
                }

                valid = self.validateTextField(medic) && type != null && treatments.length > 0 && valid;

                request.diabetes = {
                    type: type,
                    treatment: treatments,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-diabetes';
                }
            }

            // Neurological disorder
            if (document.getElementById('switch-neurologicalDisorder').checked) {
                const medic = document.getElementById('health-medic-neurologicalDisorder');
                const types = [];
                let other = null;

                if (document.getElementById('health-neurologicalDisorder_epilepsy').checked) {
                    types.push(document.getElementById('health-neurologicalDisorder_epilepsy').value);
                }
                if (document.getElementById('health-neurologicalDisorder_ms').checked) {
                    types.push(document.getElementById('health-neurologicalDisorder_ms').value);
                }
                if (document.getElementById('health-neurologicalDisorder_parkinsons').checked) {
                    types.push(document.getElementById('health-neurologicalDisorder_parkinsons').value);
                }

                request.neurologicalDisorder = {
                    type: types,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (document.getElementById('health-neurologicalDisorder_other').checked) {
                    other = document.getElementById('health-other-neurologicalDisorder_other');

                    valid = self.validateTextField(other) && valid;

                    request.neurologicalDisorder.other = {
                        conditionDescription: other.value,
                        hasCondition: true,
                    };
                }

                valid = self.validateTextField(medic) && (types.length > 0 || other) && valid;

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-neurologicalDisorder';
                }
            }

            // Immune disease
            if (document.getElementById('switch-immuneDisease').checked) {
                const medic = document.getElementById('health-medic-immuneDisease');
                const type = document.getElementById('health-immuneDisease_type');

                valid = self.validateTextField(type) && valid;
                valid = self.validateTextField(medic) && valid;

                request.immuneDisease = {
                    type: type.value,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-immuneDisease';
                }
            }

            // Blood infection
            if (document.getElementById('switch-bloodInfection').checked) {
                const medic = document.getElementById('health-medic-bloodInfection');
                const bloodInfections = {};
                let any = false;

                if (document.getElementById('health-bloodInfection_hepatitisb').checked) {
                    bloodInfections.hepatitisB = { hasConditions: true };
                    any = true;
                }
                if (document.getElementById('health-bloodInfection_hepatitisc').checked) {
                    bloodInfections.hepatitisC = { hasConditions: true };
                    any = true;
                }
                if (document.getElementById('health-bloodInfection_hiv').checked) {
                    bloodInfections.hiv = { hasConditions: true };
                    any = true;
                }

                valid = self.validateTextField(medic) && any && valid;

                request.bloodInfection = {
                    bloodInfections: bloodInfections,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-bloodInfection';
                }
            }

            // Rheumatic disease
            if (document.getElementById('switch-rheumaticDisease').checked) {
                const medic = document.getElementById('health-medic-rheumaticDisease');
                const type = document.getElementById('health-rheumaticDisease_type');
                let typeValid = self.validateTextField(type);

                valid = self.validateTextField(medic) && typeValid && valid;

                request.rheumaticDisease = {
                    type: type.value,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-rheumaticDisease';
                }
            }

            // Lung disease
            if (document.getElementById('switch-lungDisease').checked) {
                request.lungDisease = {
                    lungDiseases: {},
                    hasCondition: true,
                };

                let any = false;

                if (document.getElementById('health-lungDisease_asthma').checked) {
                    const medic = document.getElementById('health-medic-lungDisease_asthma');

                    valid = self.validateTextField(medic) && valid;
                    any = true;

                    request.lungDisease.lungDiseases.asthma = {
                        medications: medic.value,
                        hasCondition: true,
                    };
                }

                if (document.getElementById('health-lungDisease_copd').checked) {
                    const medic = document.getElementById('health-medic-lungDisease_copd');

                    valid = self.validateTextField(medic) && valid;
                    any = true;

                    request.lungDisease.lungDiseases.copd = {
                        medications: medic.value,
                        hasCondition: true,
                    };
                }

                if (document.getElementById('health-lungDisease_other').checked) {
                    const medic = document.getElementById('health-medic-lungDisease_other');
                    const other = document.getElementById('health-other-lungDisease_other');

                    valid = self.validateTextField(other) && valid;
                    valid = self.validateTextField(medic) && valid;
                    any = true;

                    request.lungDisease.lungDiseases.other = {
                        conditionDescription: other.value,
                        medications: medic.value,
                        hasCondition: true,
                    };
                }

                valid = any && valid;

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-lungDisease';
                }
            }

            // Hemophilia
            if (document.getElementById('switch-hemophilia').checked) {
                const medic = document.getElementById('health-medic-hemophilia');
                valid = self.validateTextField(medic) && valid;

                request.hemophilia = {
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-hemophilia';
                }
            }

            // Cancer
            if (document.getElementById('switch-cancer').checked) {
                const medic = document.getElementById('health-medic-cancer');
                const description = document.getElementById('health-cancer_description');
                const treatments = [];
                let effect = null;

                valid = self.validateTextField(medic) && valid;

                if (document.getElementById('health-cancer_chemotherapy').checked) {
                    treatments.push(document.getElementById('health-cancer_chemotherapy').value);
                }
                if (document.getElementById('health-cancer_radiotherapy').checked) {
                    treatments.push(document.getElementById('health-cancer_radiotherapy').value);
                }
                if (document.getElementById('health-cancer_surgery').checked) {
                    treatments.push(document.getElementById('health-cancer_surgery').value);
                }
                if (document.getElementById('health-cancer_affected_yes').checked) {
                    effect = document.getElementById('health-cancer_effect');
                    valid = self.validateTextField(effect) && valid;
                }

                valid = self.validateTextField(description) && valid;

                request.cancer = {
                    description: description.value,
                    isAffected: document.getElementById('health-cancer_affected_yes').checked,
                    effect: effect ? effect.value : null,
                    treatment: treatments,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-cancer';
                }
            }

            // Osteoporosis
            if (document.getElementById('switch-osteoporosis').checked) {
                const medic = document.getElementById('health-medic-osteoporosis');
                valid = self.validateTextField(medic) && valid;

                request.osteoporosis = {
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-osteoporosis';
                }
            }

            // MRSA
            if (document.getElementById('switch-mrsa').checked) {
                const medic = document.getElementById('health-medic-mrsa');
                valid = self.validateTextField(medic) && valid;

                request.mrsa = {
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-mrsa';
                }
            }

            // Other
            if (document.getElementById('switch-other').checked) {
                const medic = document.getElementById('health-medic-other');
                const description = document.getElementById('health-other_conditionDescription');

                valid = self.validateTextField(description) && valid;
                valid = self.validateTextField(medic) && valid;

                request.other = {
                    conditionDescription: description.value,
                    medications: medic.value,
                    hasCondition: true,
                };

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-other';
                }
            }

            // Tobacco
            if (document.getElementById('switch-tobaccoUse').checked) {
                request.tobaccoUse = {
                    hasCondition: true,
                };

                const smoke = document.getElementById('health-tobaccoUse_smoke_yes').checked;
                const waterpipe = document.getElementById('health-tobaccoUse_waterpipe_yes').checked;
                const snus = document.getElementById('health-tobaccoUse_snus_yes').checked;
                let amount = null;

                if (smoke) {
                    if (document.getElementById('health-tobaccoUse_fewerThanTenPerDay').checked) {
                        amount = document.getElementById('health-tobaccoUse_fewerThanTenPerDay').value;
                    } else if (document.getElementById('health-tobaccoUse_tenOrMorePerDay').checked) {
                        amount = document.getElementById('health-tobaccoUse_tenOrMorePerDay').value;
                    }

                    request.tobaccoUse.smoking = {
                        amount: amount,
                        hasCondition: true,
                    };

                    valid = amount != null && valid;
                } else if (!document.getElementById('health-tobaccoUse_smoke_no').checked) {
                    valid = false;
                }

                if (waterpipe) {
                    request.tobaccoUse.waterpipe = { hasCondition: true };
                } else if (!document.getElementById('health-tobaccoUse_waterpipe_no').checked) {
                    valid = false;
                }

                if (snus) {
                    request.tobaccoUse.snus = { hasCondition: true };
                } else if (!document.getElementById('health-tobaccoUse_snus_no').checked) {
                    valid = false;
                }

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-tobaccoUse';
                }
            }

            // Allergies
            if (document.getElementById('switch-allergies').checked) {
                let any = false;

                if (document.getElementById('health-allergies_penicillin').checked) {
                    any = true;
                }
                if (document.getElementById('health-allergies_localAnesthesia').checked) {
                    any = true;
                }
                if (document.getElementById('health-allergies_pollen').checked) {
                    any = true;
                }
                if (document.getElementById('health-allergies_food').checked) {
                    any = true;
                }

                valid = any && valid;

                request.allergies = {
                    penicillin: document.getElementById('health-allergies_penicillin').checked,
                    localAnesthesia: document.getElementById('health-allergies_localAnesthesia').checked,
                    pollen: document.getElementById('health-allergies_pollen').checked,
                    food: document.getElementById('health-allergies_food').checked,
                };

                if (document.getElementById('health-allergies_other').checked) {
                    const other = document.getElementById('health-other-allergies_other');

                    valid = self.validateTextField(other) && valid;
                    any = true;

                    request.allergies.other = {
                        conditionDescription: other.value,
                        hasCondition: true,
                    };
                }

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-allergies';
                }
            }

            // Pregnancy
            if (document.getElementById('switch-pregnancy').checked) {
                const dates = document.getElementsByName('health-pregnancy-date');
                let estimated = null;

                for (let i = 0; i < dates.length; i++) {
                    if (dates[i].checked) {
                        estimated = dates[i].value;
                        break;
                    }
                }

                request.pregnancy = {
                    estimatedYear: estimated ? estimated.split('-')[0] : null,
                    estimatedMonth: estimated ? estimated.split('-')[1] : null,
                    hasCondition: true,
                };

                valid = estimated != null && valid;

                if (!valid && !firstErrorAt) {
                    firstErrorAt = '#switch-pregnancy';
                }
            }
        }

        if (valid && (withoutRemark || !$.isEmptyObject(request))) {
            if (withoutRemark) {
                request = {};
            }

            opus.saveHealth(request)
                .then(() => {
                    tools.trackEvent('health');

                    $('#hd-health-saved').show(200);
                    $('#hd-mp-health-lastreg').text(tools.formatToISODate(new Date()));

                    if ($('#hd-health-saved').length) {
                        $('#hd-health-saved')[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
                    }

                    if (typeof self.saveCallback === 'function') {
                        self.saveCallback();
                    }
                })
                .catch((response) => {
                    tools.handleError(self, response, $('#hd-mp-health-error'));
                })
                .finally(() => {
                    dom.toggleSpinner('#hd-mp-health-save');
                });
        } else {
            $(firstErrorAt || '#switch-heartCondition')
                .closest('.clinic-accordion')
                .find('.health-error')
                .show();
            $(firstErrorAt || '#switch-heartCondition')
                .parent()[0]
                .scrollIntoView({ block: 'center', behavior: 'smooth' });

            dom.toggleSpinner('#hd-mp-health-save');
        }
    }

    validateTextField(field) {
        const valid = field.value !== '';

        $(field).toggleClass('required', !valid);

        return valid;
    }
}

(function (hd, _) {
    hd.views = hd.views || {};
    hd.views.healthDeclaration = new HealthDeclaration(_, hd);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);



// WEBPACK FOOTER //
// ./scripts/booking/views/health.js